import '../../themes/page-macallan.css';

jQuery(async function () {
    jQuery('.macallan-switcher-container').each(function() {
        const $container = jQuery(this);
        const $triggers = $container.find('.celebration-trigger');
        const $cards = $container.find('.macallan-product-display');

        $triggers.on('click', function() {
            const $clickedTrigger = jQuery(this);
            const productId = $clickedTrigger.data('product-id');
            
            $cards.removeClass('active').hide();
            const $nextCard = $container.find(`.macallan-product-display[data-product-id="${productId}"]`);
            $nextCard.addClass('active').fadeIn(400);
            $triggers.removeClass('active-product');
            $clickedTrigger.addClass('active-product');
        });
    });
});

